import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function usePlannings() {
  return useQuery({
    queryKey: ["plannings"],
    queryFn: () => apiClient.get("/api/v1/plannings/").then((r) => r.data),
  });
}

function usePlanning(id) {
  return useQuery({
    queryKey: ["plannings", id],
    queryFn: () => apiClient.get(`/api/v1/plannings/${id}/`).then((r) => r.data),
    enabled: !!id,
  });
}

function useCreatePlanning() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiClient.post("/api/v1/plannings/", data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["plannings"] }),
  });
}

function useUpdatePlanning(id) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiClient.patch(`/api/v1/plannings/${id}/`, data).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["plannings"] });
      qc.invalidateQueries({ queryKey: ["plannings", id] });
    },
  });
}

// Reprograma cualquier clase por id (arrastrar/redimensionar en el calendario).
// Actualiza la caché de forma optimista para que el evento se mueva al instante y
// se revierta si el backend rechaza (p. ej. 409 por conflicto de horario).
function useReschedulePlanning() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }) =>
      apiClient.patch(`/api/v1/plannings/${id}/`, data).then((r) => r.data),
    onMutate: async ({ id, date, time_start, duration }) => {
      await qc.cancelQueries({ queryKey: ["plannings"] });
      const prev = qc.getQueryData(["plannings"]);
      qc.setQueryData(["plannings"], (old) =>
        (old ?? []).map((p) =>
          p.id === id
            ? {
                ...p,
                ...(date ? { date } : {}),
                ...(time_start ? { time_start } : {}),
                ...(duration ? { duration } : {}),
              }
            : p
        )
      );
      return { prev };
    },
    onError: (_err, _vars, ctx) => {
      if (ctx?.prev) qc.setQueryData(["plannings"], ctx.prev);
    },
    onSettled: () => qc.invalidateQueries({ queryKey: ["plannings"] }),
  });
}

// GET /api/v1/teachers/ → [{id, name}] for the instructor picker.
function useTeachers() {
  return useQuery({
    queryKey: ["teachers"],
    queryFn: () => apiClient.get("/api/v1/teachers/").then((r) => r.data),
  });
}

export {
  usePlannings,
  usePlanning,
  useCreatePlanning,
  useUpdatePlanning,
  useReschedulePlanning,
  useTeachers,
};
